<div class="introduction">
  <div class="introduction-header">
    <div class="introduction-header-logo"></div>
    <app-pager
      [activePage]="activePage"
      [maxPages]="lastPage"
      (pageChange)="pageChange($event)"
    ></app-pager>
  </div>
  <div
    class="introduction-content-wrap container"
    [ngClass]="{ 'accented-page': activePage === 1 }"
  >
    <div class="introduction-content">
      <div class="introduction-icon" [ngClass]="iconClass(activePage)"></div>
      <div class="introduction-text">
        @if (activePage === 1) {
          <div>
            <h2>Wat is Vital10?</h2>
            <p>
              Beste {{ firstName }}, in het kader van {{ lastProjectName }} heb
              je toegang tot jouw eigen omgeving van Vital10.
            </p>
            <p>
              Vital10 is een ecosysteem op het gebied van gezondheid en
              duurzaamheid. Het doel is om jou en je leefomgeving vitaler te
              maken en te houden.
            </p>
            <p>
              We leggen eerst kort uit hoe MijnVital10 werkt, daarna kun je
              gelijk aan de slag.
            </p>
          </div>
        }
        @if (activePage === 2) {
          <div>
            <h2>Aan de slag</h2>
            <p>Je start met het in kaart brengen van je leefstijl.</p>
            <p>
              Je doet dit door verschillende vragen over je vitaliteit te
              beantwoorden. De vragen gaan over beïnvloedbare
              gezondheidsfactoren, zoals beweging, voeding, ontspanning en
              slaap.
            </p>
            <p>
              Op basis van wat je invult komen aandachtspunten naar voren. Je
              kunt hiervoor doelen opstellen en concrete acties aan je plan
              toevoegen. Zo geef jij jouw vitaliteit een extra boost!
            </p>
          </div>
        }
        @if (activePage === 3) {
          <div>
            <h2>Punten & beloningen</h2>
            <p>Met alle acties die je doet ontvang je v-points.</p>
            <p>
              Spaar je v-points op en gebruik ze in onze shop. Met v-points
              krijg je korting op producten of diensten die aangeboden worden
              door verschillende zorgverleners, winkels en organisaties!
            </p>
          </div>
        }
        @if (activePage === 4) {
          <div>
            <h2>Professionals</h2>
            <p>
              Professionals staan klaar om jou te helpen om aan de slag te gaan
              met jouw vitaliteit.
            </p>
          </div>
        }
        @if (activePage === 5) {
          <div>
            <h2>Ben je er klaar voor?</h2>
            <p>
              Het beste plan is het plan dat bij jou past! Daarom kun je zelf
              kiezen wat jouw focus wordt.
            </p>
            <p>Je hebt de eerste stap gezet, je kunt direct aan de slag.</p>
          </div>
        }
      </div>
      <div class="introduction-buttons">
        <app-button
          class="outline"
          (click)="pageBack()"
          [hidden]="activePage === 1"
          >Vorige</app-button
        >
        @if (activePage !== lastPage) {
          <app-button (click)="pageForward()">Volgende</app-button>
        }
        @if (activePage === lastPage) {
          <app-button (click)="finish()">Aan de slag!</app-button>
        }
      </div>
    </div>
  </div>
</div>
